import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { IMG_CLINIC } from "@/lib/images";
import { HeartHandshake, ShieldCheck, Sparkles, Clock, Users } from "lucide-react";

const promises = [
  { icon: Users, t: "Taking care of our patients", d: "We take the time to listen to our patients and treasure them. Our approachable team stays caring, helpful, and respectful, and keeps you informed in your dental care." },
  { icon: Sparkles, t: "Clean & comfortable environment", d: "We provide a clean and safe dental practice so you are comfortable and never have to worry about issues that should never come between a patient and great care." },
  { icon: Clock, t: "Convenient service", d: "We value your decision to choose us, so we respect your time. Our staff is available for any question — whether about complicated treatment or a simple insurance or billing inquiry." },
  { icon: ShieldCheck, t: "Unrivaled dental care", d: "The best care from highly trained professionals committed to your health. We treat our patients like friends and family from the second you walk in the door." },
];

export default function About() {
  return (
    <div className="App">
      <Navbar />
      <section className="max-w-6xl mx-auto px-6 pt-32 pb-16">
        <p className="label text-sm uppercase tracking-[0.15em] text-[#78698A] font-semibold">About Us</p>
        <h1 className="font-serif text-5xl text-[#2D2336] mt-3">Our promises to you</h1>
        <p className="text-lg text-[#5C5166] mt-4 max-w-2xl">
          Making your entire family smile. We will always provide the most friendly and
          professional service, every time.
        </p>

        <div className="grid md:grid-cols-2 gap-10 items-center mt-14">
          <div className="rounded-2xl overflow-hidden shadow-lg">
            <img src={IMG_CLINIC} alt="Utopia Dental Care mobile clinic" className="w-full h-[460px] object-cover" data-testid="about-founder-image" />
          </div>
          <div>
            <h2 className="font-serif text-3xl text-[#2D2336]">Our Founder</h2>
            <p className="text-[#5C5166] leading-relaxed mt-4">
              I feel so fortunate that I still love what I do after being in the dental
              field for over 32 years! Dentistry has proven to be a fantastic opportunity
              to be a part of the patients' journey towards oral health as I serve, teach,
              and grow wonderful relationships.
            </p>
            <p className="text-[#5C5166] leading-relaxed mt-4">
              I have created a system that puts our patients first by providing professional
              and affordable services. As the founder of Utopia Dental Care, my goal is to
              make each of your dental appointments as enjoyable and wellness-focused as
              possible. Hope to see you soon!
            </p>
            <p className="mt-5 font-serif text-xl text-[#6B4C8A]">Darly G. Barkley, RDH, BS</p>
          </div>
        </div>
      </section>

      <section className="bg-white border-y border-[#E5DEEB]">
        <div className="max-w-6xl mx-auto px-6 py-20">
          <h2 className="font-serif text-4xl text-[#2D2336] text-center">Our Promises</h2>
          <div className="grid md:grid-cols-2 gap-8 mt-12" data-testid="about-promises">
            {promises.map((p, i) => (
              <div key={i} className="bg-[#FBFAFC] border border-[#E5DEEB] rounded-2xl p-8">
                <p.icon className="h-8 w-8 text-[#6B4C8A]" />
                <h3 className="font-serif text-2xl text-[#2D2336] mt-4">{p.t}</h3>
                <p className="text-[#5C5166] leading-relaxed mt-2">{p.d}</p>
              </div>
            ))}
          </div>
          <div className="mt-12 bg-[#F3EFF7] border border-[#C8B3D6] rounded-2xl p-8 text-center">
            <HeartHandshake className="h-8 w-8 text-[#6B4C8A] mx-auto" />
            <p className="text-[#5C5166] leading-relaxed mt-3 max-w-2xl mx-auto">
              Please let us know if we have fallen behind on any of our promises to you —
              we strive to listen to our patients' constructive assessments.
            </p>
            <p className="mt-4 font-serif text-lg text-[#6B4C8A]">Utopia Dental Care, LLC</p>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
